import { render, staticRenderFns } from "./RegisterSec.vue?vue&type=template&id=7d1ffcd5&scoped=true"
import script from "./RegisterSec.vue?vue&type=script&lang=js"
export * from "./RegisterSec.vue?vue&type=script&lang=js"
import style0 from "./RegisterSec.vue?vue&type=style&index=0&id=7d1ffcd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ffcd5",
  null
  
)

export default component.exports